import React, { useState, useEffect } from 'react';
import Headers from './Component/Header';
import Footer from './Component/Footer';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import home5 from './Component/productheader.jpg';

const typeOptions = [
  { id: 'carpet', value: 'carpet', label: 'Carpet (7514)' },
  { id: 'glasstile', value: 'glasstile', label: 'Glass Tile (187)' },
  { id: 'metaltile', value: 'metaltile', label: 'Metal Tile (69)' },
  { id: 'hardwood', value: 'hardwood', label: 'Hardwood (415)' },
  { id: 'Tile', value: 'Tile', label: 'Tile (1444)' },
  { id: 'luxuryvinyl', value: 'luxuryvinyl', label: 'Luxury Vinyl (1026)' },
];

function Glasstile() {
  const { id } = useParams();
  const [imageData, setImageData] = useState([]);
  const [uniquebrand, setuniquebrand] = useState([]);
  const [uniquewidth, setuniquewidth] = useState([]);
  const [uniqueFiberType, setuniqueFiberType] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 12;
  const startIndex = currentPage * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const pageData = imageData.slice(startIndex, endIndex);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const formdata = {
          idd: id,
        };
        const imageDataResponse = await axios.post(
          `${process.env.REACT_APP_API_URL}/api/fetchimage`,
          formdata
        );
        setImageData(imageDataResponse.data.data1);
        setuniquebrand(imageDataResponse.data.data2);
        setuniquewidth(imageDataResponse.data.data3);
        setuniqueFiberType(imageDataResponse.data.data4);
        setCurrentPage(0);
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, [id]);

  const handlepropertyselect = (skuId, category) => {
    navigate(`/products/${category}/${skuId}`);
    window.scrollTo(0, 0);
  };

  const totalPages = Math.ceil(imageData.length / itemsPerPage) || 1;

  const handleNextPage = () => {
    setCurrentPage(currentPage + 1 < totalPages ? currentPage + 1 : totalPages - 1);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handlePrevPage = () => {
    setCurrentPage(currentPage > 0 ? currentPage - 1 : 0);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handlePageClick = (page) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const renderPaginationButtons = () => {
    const buttons = [];
    for (let i = currentPage; i < totalPages && i < currentPage + 4; i++) {
      buttons.push(
        <button
          key={i}
          type="button"
          onClick={() => handlePageClick(i)}
          className={`min-w-[40px] h-10 rounded-lg text-sm font-semibold transition-colors ${
            currentPage === i
              ? 'bg-[#803333] text-white'
              : 'bg-white text-gray-700 border border-gray-200 hover:border-[#803333] hover:text-[#803333]'
          }`}
        >
          {i + 1}
        </button>
      );
    }
    return buttons;
  };

  const [formData, setFormData] = useState({
    Types: '',
    brand: null,
    Color_Tones: null,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const imageDataResponse = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/fetchimage/similarimage`,
        formData
      );
      setImageData(imageDataResponse.data.data1);
      setuniquebrand(imageDataResponse.data.data2);
      setuniquewidth(imageDataResponse.data.data3);
      setuniqueFiberType(imageDataResponse.data.data4);
      setCurrentPage(0);
      onCloseMenu();
    } catch (error) {
      console.error(error);
    }
  };

  const handleReset = () => {
    setFormData({
      Types: '',
      brand: null,
      Color_Tones: null,
    });
  };

  const [menuOpen, setMenuOpen] = useState(false);

  const onToggleMenu = () => {
    setMenuOpen(true);
  };
  const onCloseMenu = () => {
    setMenuOpen(false);
  };

  const [visibleItems, setVisibleItems] = useState(4);
  const showMoreItems = () => {
    setVisibleItems(visibleItems + 4);
  };

  const categoryTitle = (id || 'Products').replace(/-/g, ' ');

  const FilterForm = ({ showClose }) => (
    <form className="space-y-5" onSubmit={handleSubmit}>
      <fieldset className="border-0 p-0 m-0">
        <legend className="text-xs font-semibold uppercase tracking-wide text-gray-500 mb-3 float-none w-auto p-0">
          Types
        </legend>
        <div className="space-y-2">
          {typeOptions.map((option) => (
            <label
              key={option.id}
              htmlFor={option.id}
              className={`flex items-center gap-2.5 rounded-lg border px-3 py-2 text-sm cursor-pointer transition-colors ${
                formData.Types === option.value
                  ? 'border-[#803333] bg-[#803333]/5 text-[#803333]'
                  : 'border-gray-200 text-gray-700 hover:border-gray-300'
              }`}
            >
              <input
                type="radio"
                id={option.id}
                name="Types"
                value={option.value}
                onChange={handleChange}
                checked={formData.Types === option.value}
                required
                className="accent-[#803333]"
              />
              {option.label}
            </label>
          ))}
        </div>
      </fieldset>

      <fieldset className="border-0 p-0 m-0">
        <legend className="text-xs font-semibold uppercase tracking-wide text-gray-500 mb-3 float-none w-auto p-0">
          Brands
        </legend>
        <div className="space-y-2 max-h-48 overflow-y-auto pr-1">
          {uniquebrand.map((item) => (
            <label
              key={item.Brand}
              htmlFor={item.Brand}
              className={`flex items-center gap-2.5 rounded-lg border px-3 py-2 text-sm cursor-pointer transition-colors ${
                formData.brand === item.Brand
                  ? 'border-[#803333] bg-[#803333]/5 text-[#803333]'
                  : 'border-gray-200 text-gray-700 hover:border-gray-300'
              }`}
            >
              <input
                type="radio"
                id={item.Brand}
                name="brand"
                value={item.Brand}
                onChange={handleChange}
                checked={formData.brand === item.Brand}
                className="accent-[#803333]"
              />
              {item.Brand}
            </label>
          ))}
        </div>
      </fieldset>

      <fieldset className="border-0 p-0 m-0">
        <legend className="text-xs font-semibold uppercase tracking-wide text-gray-500 mb-3 float-none w-auto p-0">
          Color Tones
        </legend>
        <div className="space-y-2">
          {uniqueFiberType.slice(0, visibleItems).map(
            (item) =>
              item.Color_Tones && (
                <label
                  key={item.Color_Tones}
                  htmlFor={item.Color_Tones}
                  className={`flex items-center gap-2.5 rounded-lg border px-3 py-2 text-sm cursor-pointer transition-colors ${
                    formData.Color_Tones === item.Color_Tones
                      ? 'border-[#803333] bg-[#803333]/5 text-[#803333]'
                      : 'border-gray-200 text-gray-700 hover:border-gray-300'
                  }`}
                >
                  <input
                    type="radio"
                    id={item.Color_Tones}
                    name="Color_Tones"
                    value={item.Color_Tones}
                    onChange={handleChange}
                    checked={formData.Color_Tones === item.Color_Tones}
                    className="accent-[#803333]"
                  />
                  {item.Color_Tones}
                </label>
              )
          )}
          {visibleItems < uniqueFiberType.length && (
            <button
              type="button"
              onClick={showMoreItems}
              className="text-sm font-medium text-[#803333] hover:underline bg-transparent border-0 p-0"
            >
              More items
            </button>
          )}
        </div>
      </fieldset>

      <div className="flex gap-2 pt-1">
        <button
          type="button"
          className="flex-1 py-2.5 rounded-lg text-sm font-semibold border border-gray-200 text-gray-700 hover:bg-gray-50 transition-colors bg-white"
          onClick={handleReset}
        >
          Reset
        </button>
        <button
          type="submit"
          className="flex-1 py-2.5 rounded-lg text-sm font-semibold text-white border-0 hover:opacity-90 transition-opacity"
          style={{ backgroundColor: '#803333' }}
        >
          Apply
        </button>
      </div>

      {showClose && (
        <button
          type="button"
          className="w-full py-2.5 rounded-lg text-sm font-semibold text-gray-600 border border-gray-200 bg-white hover:bg-gray-50"
          onClick={onCloseMenu}
        >
          Close filters
        </button>
      )}
    </form>
  );

  return (
    <div className="bg-gray-50 min-h-screen">
      <Headers />

      {/* Hero */}
      <section
        className="relative bg-cover bg-center"
        style={{ backgroundImage: `url(${home5})` }}
      >
        <div className="absolute inset-0 bg-[#803333]/80" />
        <div className="relative container mx-auto px-4 py-14 md:py-20 text-center text-white">
          <h1 className="text-3xl md:text-4xl font-bold capitalize mb-2 tracking-tight">
            {categoryTitle}
          </h1>
          <p className="text-white/85 text-sm md:text-base mb-6 max-w-xl mx-auto">
            Wide variety of styles from Nickle&apos;s Flooring in Cassville, MO
          </p>
          <a
            href="#product-grid"
            className="inline-flex items-center gap-2 bg-white text-[#803333] font-semibold text-sm px-5 py-2.5 rounded-lg no-underline hover:bg-white/90 transition-colors"
          >
            View our selection
            <i className="bi bi-arrow-down" />
          </a>
        </div>
      </section>

      <div className="container mx-auto px-4 py-8 md:py-12" id="product-grid">
        {/* Mobile filter toggle */}
        <div className="lg:hidden mb-4">
          <button
            type="button"
            onClick={onToggleMenu}
            className="inline-flex items-center gap-2 bg-white border border-gray-200 rounded-lg px-4 py-2.5 text-sm font-semibold text-gray-800 shadow-sm"
          >
            <i className="bi bi-funnel" />
            Filters
          </button>
        </div>

        <div className="row g-4">
          {/* Desktop filters */}
          <aside className="col-lg-3 d-none d-lg-block">
            <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-5 sticky top-24">
              <h2 className="text-base font-bold text-gray-900 mb-4">Filter products</h2>
              <FilterForm showClose={false} />
            </div>
          </aside>

          {/* Product grid */}
          <div className="col-lg-9">
            <div className="flex flex-wrap items-end justify-between gap-2 mb-5">
              <div>
                <h2 className="text-xl md:text-2xl font-bold text-gray-900 m-0 capitalize">
                  {categoryTitle}
                </h2>
                <p className="text-sm text-gray-500 m-0 mt-1">
                  {imageData.length} products from Nickle&apos;s Flooring in Cassville, MO
                </p>
              </div>
            </div>

            {pageData.length === 0 ? (
              <div className="bg-white rounded-2xl border border-gray-100 p-10 text-center text-gray-500">
                No products found. Try adjusting your filters.
              </div>
            ) : (
              <div className="row g-3 g-md-4 mb-6">
                {pageData.map((item) => (
                  <div key={item.SKU} className="col-6 col-md-4" id={item.Brand}>
                    <button
                      type="button"
                      onClick={() => handlepropertyselect(item.SKU, item.Type)}
                      className="group w-100 h-100 bg-white rounded-xl border border-gray-100 shadow-sm overflow-hidden text-start p-0 transition-all hover:-translate-y-1 hover:shadow-md"
                    >
                      <div className="aspect-square bg-gray-100 overflow-hidden">
                        <img
                          src={require('./Component/photo/' + item.SKU + '.png')}
                          alt={item.Title || `${item.Brand} ${item.Product_Line}`}
                          title={item.Title}
                          className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.style.display = 'none';
                          }}
                        />
                      </div>
                      <div className="p-3 md:p-4">
                        <p className="text-xs text-gray-500 m-0 mb-1">{item.Brand}</p>
                        <p className="text-sm font-semibold text-gray-900 m-0 mb-1 line-clamp-2">
                          {item.Product_Line}
                        </p>
                        <p className="text-xs text-gray-600 m-0 mb-3">{item.Color}</p>
                        <span
                          className="inline-flex w-full items-center justify-center text-white text-xs font-semibold py-2 rounded-lg"
                          style={{ backgroundColor: '#803333' }}
                        >
                          See more colors
                        </span>
                      </div>
                    </button>
                  </div>
                ))}
              </div>
            )}

            {imageData.length > itemsPerPage && (
              <nav className="flex flex-wrap items-center justify-center gap-2" aria-label="Product pagination">
                <button
                  type="button"
                  onClick={handlePrevPage}
                  disabled={currentPage === 0}
                  className="h-10 px-4 rounded-lg text-sm font-semibold text-white border-0 disabled:opacity-40"
                  style={{ backgroundColor: '#803333' }}
                >
                  « Previous
                </button>
                {renderPaginationButtons()}
                <button
                  type="button"
                  onClick={handleNextPage}
                  disabled={currentPage >= totalPages - 1}
                  className="h-10 px-4 rounded-lg text-sm font-semibold text-white border-0 disabled:opacity-40"
                  style={{ backgroundColor: '#803333' }}
                >
                  Next »
                </button>
              </nav>
            )}
          </div>
        </div>
      </div>

      {/* Mobile filter drawer */}
      {menuOpen && (
        <div className="lg:hidden fixed inset-0 z-[60]">
          <button
            type="button"
            className="absolute inset-0 bg-black/40 border-0 w-full h-full"
            aria-label="Close filters"
            onClick={onCloseMenu}
          />
          <div className="absolute inset-y-0 left-0 w-[min(100%,320px)] bg-white shadow-xl overflow-y-auto p-5">
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-base font-bold text-gray-900 m-0">Filter products</h2>
              <button
                type="button"
                onClick={onCloseMenu}
                className="w-9 h-9 rounded-lg flex items-center justify-center border-0 bg-gray-100 text-gray-700"
                aria-label="Close"
              >
                <i className="bi bi-x-lg" />
              </button>
            </div>
            <FilterForm showClose />
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
}

export default Glasstile;
